/**
 * Constantes para las rutas de assets
 * Centraliza las rutas a recursos estáticos para facilitar su mantenimiento
 */

export const ASSETS_PATHS = {
  // Imágenes
  IMAGES: {
    LOGO: 'assets/images/logo.svg',
    LOGO_FULL: 'assets/images/logo-completo.png',
    LOGO_WHITE: 'assets/images/logo.png',
    LOGO_COMPLETO: 'assets/images/logo-completo.png',
    FAVICON: 'assets/images/favicon.ico',
    DEFAULT_AVATAR: 'assets/images/default-avatar.png',
    BACKGROUNDS: {
      LOGIN: 'assets/images/backgrounds/login-bg.jpg',
      MENU: 'assets/images/backgrounds/menu.svg'
    },
    MODULES: {
      DESCRIPCION: 'assets/images/modules/descripcion.svg',
    }
  },
  
  // Iconos
  ICONS: {
    CUSTOM: {
      DOCUMENTO: 'assets/icons/custom/documento.svg',
    }
  },
  
  // Fuentes
  FONTS: 'assets/fonts/'
};
